import Color from 'color';
export const convertToDarkerRgba = (color) => color && Color(color).darken(0.4).rgb().string();
//# sourceMappingURL=convertToDarkerRgba.js.map